import request from '@/utils/request';
import { uuid } from 'vue-uuid'
import { obj2query } from '@/utils'
import { getToken } from '@/utils/auth'

export function getFirewallTransactions(projectuid, data) {
  return request({
    url: `/api/firewall/report/project/${projectuid}`,
    method: "post",
    data
  })
}

export function reportFirewallTransactionsExcel(projectuid, data, filename) {
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  data.token = getToken()
  link.href = `${baseURL}/api/firewall/report/project/${projectuid}/excel${obj2query(data)}`
  if (filename) {
    link.download = filename
  }
  link.click()
}

export function getFirewallSummary(projectuid, data) {
  return request({
    url: `/api/firewall/report/project/${projectuid}/summary`,
    method: "post",
    data
  })
}

export function reportFirewallSummaryExcel(projectuid, data, filename) {
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  data.token = getToken()
  link.href = `${baseURL}/api/firewall/report/project/${projectuid}/summary/excel${obj2query(data)}`
  if (filename) {
    link.download = filename
  }
  link.click()
}

export function getFirewallSummaryCustomer(projectuid, data) {
  return request({
    url: `/api/firewall/report/project/${projectuid}/summary/customer`,
    method: "post",
    data
  })
}

export function reportFirewallSummaryCustomerExcel(projectuid, data, filename) {
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  data.token = getToken()
  link.href = `${baseURL}/api/firewall/report/project/${projectuid}/summary/customer/excel${obj2query(data)}`
  if (filename) {
    link.download = filename
  }
  link.click()
}

export function getFirewallMonitorSummary(projectuid, data) {
  return request({
    url: `/api/firewall/report/project/${projectuid}/firewallmonitorsummary`,
    method: "post",
    data
  })
}

export function reportFirewallMonitorSummaryExcel(projectuid, data, filename) {
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  data.token = getToken()
  link.href = `${baseURL}/api/firewall/report/project/${projectuid}/firewallmonitorsummary/excel${obj2query(data)}`
  if (filename) {
    link.download = filename
  }
  link.click()
}

export function getFirewallTransactionsDetail(paymentuid) {
  return request({
    url: `/api/firewall/report/transaction/detail/${paymentuid}`,
    method: "get"
  })
}